export default "__VITE_PUBLIC_ASSET__62ec89ba__"